/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
import * as Types from '../../../../queryTyping';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type GetUserContactsSettingsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetUserContactsSettingsQuery = (
  { __typename?: 'Query' }
  & { userContactSettings: (
    { __typename?: 'GetContactsAndSettingsConfigurationResult' }
    & Pick<Types.GetContactsAndSettingsConfigurationResult, 'isAllowedAlertChannelsSmsAlertEnabled' | 'isAlertsBySmsEnabledForAllUsers' | 'checkPrimaryEmailStatusOnLogin' | 'isDeletePrimaryWorkPhoneEnabled' | 'isForeignAddressEnabled' | 'isInternationalPhoneEnabled' | 'isUsingSameNumberForWorkHomeMobilePhoneEnabled' | 'maxAutomaticLogOffAfterMin' | 'isChangeTimeZoneEnabled'>
  ) }
);


export const GetUserContactsSettingsDocument = gql`
    query GetUserContactsSettings {
  userContactSettings {
    isAllowedAlertChannelsSmsAlertEnabled
    isAlertsBySmsEnabledForAllUsers
    checkPrimaryEmailStatusOnLogin
    isDeletePrimaryWorkPhoneEnabled
    isForeignAddressEnabled
    isInternationalPhoneEnabled
    isUsingSameNumberForWorkHomeMobilePhoneEnabled
    maxAutomaticLogOffAfterMin
    isChangeTimeZoneEnabled
  }
}
    `;

/**
 * __useGetUserContactsSettingsQuery__
 *
 * To run a query within a React component, call `useGetUserContactsSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserContactsSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserContactsSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserContactsSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserContactsSettingsQuery, GetUserContactsSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserContactsSettingsQuery, GetUserContactsSettingsQueryVariables>(GetUserContactsSettingsDocument, options);
      }
export function useGetUserContactsSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserContactsSettingsQuery, GetUserContactsSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserContactsSettingsQuery, GetUserContactsSettingsQueryVariables>(GetUserContactsSettingsDocument, options);
        }
export type GetUserContactsSettingsQueryHookResult = ReturnType<typeof useGetUserContactsSettingsQuery>;
export type GetUserContactsSettingsLazyQueryHookResult = ReturnType<typeof useGetUserContactsSettingsLazyQuery>;
export type GetUserContactsSettingsQueryResult = Apollo.QueryResult<GetUserContactsSettingsQuery, GetUserContactsSettingsQueryVariables>;